import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { communicationAnalyticsReducer } from './communication-analytics.reducer';
import { CommunicationAnalyticsEffects } from './communication-analytics.effects';

@NgModule({
  imports: [
    StoreModule.forFeature('communicationAnalytics', communicationAnalyticsReducer),
    EffectsModule.forFeature([CommunicationAnalyticsEffects])
  ]
})
export class CommunicationAnalyticsStateModule {}
